"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const base_ui_components_atoms_typography_1 = require("@motorata/base-ui.components.atoms.typography");
const base_ui_components_atoms__atoms_1 = require("@motorata/base-ui.components.atoms._atoms");
const base_ui_components_atoms_icon_1 = __importDefault(require("@motorata/base-ui.components.atoms.icon"));
const base_ui_components_atoms_button_1 = __importDefault(require("@motorata/base-ui.components.atoms.button"));
const Accordion = (_a) => {
    var { title, icon, className, children, footerChildren, wrapperProps, background, titleColor = "second", collapseable = false } = _a, rest = __rest(_a, ["title", "icon", "className", "children", "footerChildren", "wrapperProps", "background", "titleColor", "collapseable"]);
    const [show, setShow] = (0, react_1.useState)(!collapseable);
    return (react_1.default.createElement(Wrapper, Object.assign({ className: `sidebar_block ${className}`, background: background }, wrapperProps),
        title && (react_1.default.createElement(TitleContent, { padding: "S" },
            react_1.default.createElement(base_ui_components_atoms__atoms_1.Row, { alignItems: "center" },
                icon && react_1.default.createElement(base_ui_components_atoms_icon_1.default, { icon: icon }),
                react_1.default.createElement(base_ui_components_atoms_typography_1.Title, { color: titleColor, type: "third", margin: "0", elementType: "label" }, title)))),
        react_1.default.createElement(Content, Object.assign({ padding: "S", show: show }, rest), children),
        footerChildren && react_1.default.createElement(FooterContent, null, footerChildren),
        collapseable && (react_1.default.createElement(CollapseContent, null,
            react_1.default.createElement(base_ui_components_atoms_button_1.default, { type: "third", onClick: () => setShow(!show) }, show ? "Zobacz mniej" : "Zobacz więcej")))));
};
exports.default = Accordion;
const Content = (0, styled_components_1.default)(base_ui_components_atoms__atoms_1.Box) `
  white-space: break-spaces;
  position: relative;
  max-height: 200px;
  overflow: hidden;

  &:before {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(0deg, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0) 100%);
    content: "";
  }

  ${({ show }) => show &&
    (0, styled_components_1.css) `
      max-height: none;

      &:before {
        display: none;
      }
    `}
`;
const FooterContent = (0, styled_components_1.default)(base_ui_components_atoms__atoms_1.Box) `
  padding: ${({ theme }) => theme.space.S};
  border-top: 1px solid ${({ theme }) => theme.color.fourth};
`;
const CollapseContent = (0, styled_components_1.default)(base_ui_components_atoms__atoms_1.Box) `
  padding: 0;
  display: flex;
  justify-content: center;
  border-top: 1px solid ${({ theme }) => theme.color.fourth};
`;
const TitleContent = (0, styled_components_1.default)(base_ui_components_atoms__atoms_1.Box) `
  border-bottom: ${({ theme }) => `1px solid ${theme.color.fourth}`};
  display: flex;
  justify-content: space-between;

  svg {
    width: ${({ theme }) => theme.font.XL};
    margin-right: ${({ theme }) => theme.space.XS};
  }
`;
const Wrapper = (0, styled_components_1.default)(base_ui_components_atoms__atoms_1.Box) `
  background: ${({ theme, background = "white" }) => theme.color[background]};
  padding: 0px;
  border-radius: 5px;
  overflow: hidden;
  box-shadow: ${({ theme }) => theme.variable.boxShadow};
`;
//# sourceMappingURL=index.js.map